export const isValidResponse = (status?: number): boolean =>
  `${status}`.split('')[0] === '2';

export const isConflictResponse = (status?: number): boolean =>
status === 409;
